/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Approved_TitleInputs */

const en_mcp_connect_approved_title = /** @type {(inputs: Mcp_Connect_Approved_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access approved`)
};

const es_mcp_connect_approved_title = /** @type {(inputs: Mcp_Connect_Approved_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso aprobado`)
};

/**
* | output |
* | --- |
* | "Access approved" |
*
* @param {Mcp_Connect_Approved_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_approved_title = /** @type {((inputs?: Mcp_Connect_Approved_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Approved_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_approved_title(inputs)
	return en_mcp_connect_approved_title(inputs)
});